import '../utilities/index.js';
import './doubleclick.js';